import useAppSelector from "./useAppSelector";
export default function useFeatureIsEnabled() {
    var features = useAppSelector(function (state) { return state.configuration; }).features;
    return function (feature) { return features.includes(feature); };
}
